module.exports = __webpack_public_path__ + "static/img/popup.618874c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/popup.png
// module id = c1sA
// module chunks = 52